import axios from './BaseService'

const GAMES_URL = `${process.env.REACT_APP_API_URL}/games/`

export async function getGames(token, page, limit, status) {
  const endPoint = `${GAMES_URL}listgames${page ? `?page=${page}` : ''}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, { status, limit }, { headers })
  return response.data
}

export async function getGame(id, token) {
  const endPoint = `${GAMES_URL}getgame/${id}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.get(endPoint, { headers })
  return response.data
}

export async function getBets(token, page, limit, search, status, searchUser) {
  const endPoint = `${GAMES_URL}listbets${page ? `?page=${page}` : ''}`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, { status, limit, search, searchUser }, { headers })
  return response.data
}

export async function sendCloseAndNewGame(data, token) {
  const endPoint = `${GAMES_URL}closeandnewgame`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, data, { headers })
  return response.data
}

export async function sendEditGame(data, token) {
  const endPoint = `${GAMES_URL}sendeditgame`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, data, { headers })
  return response.data
}

export async function createNewGame(data, token) {
  const endPoint = `${GAMES_URL}createnewgame`
  const headers = { 'Content-Type': 'application/json', Authorization: `${token}` }
  const response = await axios.post(endPoint, data, { headers })
  return response.data
}
